import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=5a781f88&"
import script from "./DoctorForm.vue?vue&type=script&lang=js&"
export * from "./DoctorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports